import { createAsyncThunkFromFetch } from 'src/store/utils';
import { fetchBatteryLogsAPI } from './battery.api';
import {
  FetchBatteryLogsParams,
  FetchBatteryLogsResponse,
} from './battery.types';

export const fetchBatteryLogsAction = createAsyncThunkFromFetch<
  FetchBatteryLogsResponse,
  FetchBatteryLogsParams
>('headsets/battery', fetchBatteryLogsAPI);
